import React, { ReactNode } from 'react';
import useFeatureToggleService, { ToggledFeature } from './featureToggleService';
import { SimpleBlock } from 'ui-builder';
import styles from './ToggleWrapper.module.scss';

export interface ToggleWrapperProps {
  children: ReactNode;
}

export interface BaseToggleWrapperProps extends ToggleWrapperProps {
  feature: ToggledFeature,
  showInDevelopment?: boolean,
}

export function ToggleWrapper(
  props: BaseToggleWrapperProps,
) {
  const featureToggleService = useFeatureToggleService();

  if (featureToggleService.isFeatureEnabled(props.feature)) {
    const isInDevelopment = featureToggleService.isInDevelopment(props.feature);

    if (props.showInDevelopment && isInDevelopment) {
      return (
        <SimpleBlock className={styles.inDevelopment} title="This feature is under development and it's not available for common user.">
          {props.children}
        </SimpleBlock>
      );
    } else {
      return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
          {props.children}
        </>
      );
    }
  } else {
    return null;
  }
}
